export default __webpack_public_path__ + "static/media/gb.6b529cd9.svg";